// extracted by mini-css-extract-plugin
module.exports = {"instructorImage":"InstructorImage_instructorImage__n6lQL"};